<template>
    <div class="wrapper">
        <parallax
                class="section page-header header-filter"
                parallax-active="true"
                :style="headerStyle"
        >
            <div class="container">
                <div class="md-layout">
                    <div class="md-layout-item md-size-50 md-small-size-100">
                        <h1 class="title">
                            Приложения для ЭВОТОР.
                        </h1>

                        <h3 class="title"> Приложениями для ЭВОТОР от VIDA-SOFT пользуются десятки тысяч клиентов по всей России.</h3>
                        <br>
                    </div>
                </div>
            </div>
        </parallax>
        <div class="main main-raised">
          <a name="app"></a>
            <div class="section">
                <div class="container">
                    <div class="md-layout">
                        <div class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center">
                            <h2 class="title text-center">
                                Наши приложения для ЭВОТОР
                            </h2>
                            <h5  class="info-title">
                                Мы занимаемся разработкой приложений для ЭВОТОР с момента осномания платформы.
                                Накопленный нами опыт позволяет решать  задачи любой сложности связанные со
                                смарт-терминалом ЭВОТОР и их интеграции с различными системами.
                            </h5>
                        </div>
                    </div>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100 mx-auto">
                            <h2 class="title text-center">
                                Обмен данными ЭВОТОР с 1С:Предприятие 8.0 и Техподдержка
                            </h2>
                            <p  class="info-title">
                                Приложение для интеграции 1С и ККМ ЭВОТОР.
                                Автоматический обмен 1С с ЭВОТОР. Синхронизация номенклатуры,
                                характеристик, цен, штрихкодов. Загрузка в 1С созданных на ЭВОТОР
                                документов. Работает с ЕГАИС, маркировкой, поддерживает 1С-FRESH.
                            </p>
                            <p  class="info-title">Зарегистрировано в реестре российского программного обеспечения, № записи 9419, дата регистрации 01.03.2021</p>
                            <p><a href="../../docs/1с/opf.pdf">Описание функциональных характеристик программного обеспечения</a></p>
                            <p><a href="../../docs/1с/proces.pdf">Процессы жизненного цикла</a></p>
                            <p><a href="../../docs/1с/adminman.pdf">Руководство администратора</a></p>
                            <p><a href="../../docs/1с/userguide.pdf">Руководство пользователя</a></p>
                            <p  class="info-title">Приложение имеет несколько альтернативных наименований, распространяется, устанавливается и продается через магазин приложений ЭВОТОР.</p>
                            <p  class="info-title">Цена одной лицензии на месяц 510 рублей.</p>
                        </div>
                    </div>
                    <div class="features text-center">
                        <div class="md-layout">
                            <div class="md-layout-item md-large-size-25 md-mediu m-size-33 md-small-size-100">
                                <md-card class="md-card-custom1">
                                    <div>
                                        <img
                                                class="img kd-3"
                                                :src="image_1c_un"
                                        />
                                    </div>
                                    <md-card-content>
                                        <div class="md-layout">
                                            <div class="md-layout-item md-size-100">
                                                <div class="md-layout-item">
                                                    <h6 class="card-category text-gray">
                                                        Обмен с 1С
                                                    </h6>
                                                    <h3 class="card-title">
                                                        Интеграция с 1С 8.
                                                    </h3>
                                                </div>
                                                <div class="md-layout-item md-size-100">
                                                    <div class="kd-2">
                                                        <a href="https://market.evotor.ru/store/basket/shared/mbLGrLZ0bV0aW">
                                                            <md-button class="md-simple md-round">
                                                                Установить
                                                            </md-button>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </md-card-content>
                                </md-card>
                            </div>
                            <div class="md-layout-item md-large-size-25 md-medium-size-33 md-small-size-100">
                                <md-card class="md-card-custom1">
                                    <div>
                                        <img
                                                 class="img kd-3"
                                                :src="image_1c_torg"
                                                
                                        />
                                    </div>
                                    <md-card-content>
                                        <div class="md-layout">
                                            <div class="md-layout-item md-size-100">
                                                <h6 class="card-category text-gray">
                                                    Обмен с 1С
                                                </h6>
                                                <h3 class="card-title">
                                                    1С8:Торговля, ред 10.3-11.4
                                                </h3>
                                            </div>
                                            <div class="md-layout-item md-size-100">
                                                <div class="kd-2">
                                                    <a href="https://market.evotor.ru/store/basket/shared/NZq6d5zlnZ5Dd">
                                                        <md-button class="md-simple md-round">
                                                            Установить
                                                        </md-button>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </md-card-content>
                                </md-card>
                            </div>
                            <div class="md-layout-item md-large-size-25 md-medium-size-33 md-small-size-100">
                                <md-card class="md-card-custom1">
                                    <div>
                                        <img
                                                 class="img kd-3"
                                                :src="image_1c_buh"
                                                
                                        />
                                    </div>
                                    <md-card-content>
                                        <div class="md-layout">
                                            <div class="md-layout-item md-size-100">
                                                <h6 class="card-category text-gray">
                                                    Обмен с 1С
                                                </h6>
                                                <h3 class="card-title">
                                                    1С8:Бухгалтерия, ред. 2.0-3.0
                                                </h3>
                                                <div class="md-layout-item md-size-100">
                                                    <div class="kd-2">
                                                        <a href="https://market.evotor.ru/store/basket/shared/WJ7304QLmm648">
                                                            <md-button class="md-simple md-round">
                                                                Установить
                                                            </md-button>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </md-card-content>
                                </md-card>
                            </div>
                            <div class="md-layout-item md-large-size-25 md-medium-size-33 md-small-size-100">
                                <md-card class="md-card-custom1">
                                    <div>
                                        <img
                                                class="img kd-3"
                                                :src="image_1c_rozn"
                                                
                                        />
                                    </div>
                                    <md-card-content>
                                        <div class="md-layout">
                                            <div class="md-layout-item md-size-100">
                                                <h6 class="card-category text-gray">
                                                    Обмен с 1С
                                                </h6>
                                                <h3 class="card-title">
                                                    1С8:Розница, ред. 1.0 - 2.3
                                                </h3>
                                            </div>
                                            <div class="md-layout-item md-size-100">
                                                <div class="kd-2">
                                                    <a href="https://market.evotor.ru/store/basket/shared/za93DzMVW7w03">
                                                        <md-button class="md-simple md-round">
                                                            Установить
                                                        </md-button>
                                                    </a>
                                                </div>
                                            </div>

                                        </div>
                                    </md-card-content>
                                </md-card>
                            </div>
                            <div class="md-layout-item md-large-size-25 md-medium-size-33 md-small-size-100">
                                <md-card class="md-card-custom1" style="min-width: 250px;">
                                    <div>
                                        <img
                                                 class="img kd-3"
                                                :src="image_1c_zakaz"
                                                
                                        />
                                    </div>
                                    <md-card-content>
                                        <div class="md-layout">
                                            <div class="md-layout-item md-size-100">
                                                <h6 class="card-category text-gray">
                                                    Обмен с 1С
                                                </h6>
                                                <h3 class="card-title">
                                                    Обмен с 1С + Заказ в 1С
                                                </h3>
                                            </div>
                                            <div class="md-layout-item md-size-100">
                                                <div class="kd-2">
                                                    <a href="https://market.evotor.ru/store/basket/shared/9GQg20agPX23m">
                                                        <md-button class="md-simple md-round">
                                                            Установить
                                                        </md-button>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </md-card-content>
                                </md-card>
                            </div>
                            <div class="md-layout-item md-large-size-25 md-medium-size-33 md-small-size-100">
                                <md-card class="md-card-custom1">
                                    <div>
                                        <img
                                                 class="img kd-3"
                                                :src="image_1c_7"
                                        />
                                    </div>
                                    <md-card-content>
                                        <div class="md-layout">
                                            <div class="md-layout-item md-size-100">
                                                <h6 class="card-category text-gray">
                                                    Обмен с 1С
                                                </h6>
                                                <h3 class="card-title">
                                                    Интеграция 1С 7.7
                                                </h3>
                                            </div>
                                            <div class="md-layout-item md-size-100">
                                                <div class="kd-2">
                                                    <a href="https://market.evotor.ru/store/basket/shared/om4mnOZpxkDqM">
                                                        <md-button class="md-simple md-round">
                                                            Установить
                                                        </md-button>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </md-card-content>
                                </md-card>
                            </div>
                        </div>
                    </div>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100 mx-auto">
                            <h2 class="title text-center">
                                Печать чека по документу полученному из 1С
                            </h2>
                            <p  class="info-title">
                                Приложение для интеграции 1С и ККМ ЭВОТОР.
                                Незаменимое приложение для оптовой торговли, служб доставки и
                                случаев когда необходимо пробить чек по заранее созданному
                                документу.
                                Приложение дополняет ЭВОТОР возможностью печатать чек по документу
                                полученному из 1С.
                            </p>
                            <p  class="info-title">Зарегистрировано в реестре российского программного обеспечения, № записи 10608, дата регистрации 27.05.2021</p>
                            <p><a href="../../docs/chpd/opf.pdf">Описание функциональных характеристик программного обеспечения</a></p>
                            <p><a href="../../docs/chpd/proces.pdf">Процессы жизненного цикла</a></p>
                            <p><a href="../../docs/chpd/adminman.pdf">Руководство администратора</a></p>
                            <p><a href="../../docs/chpd/userguide.pdf">Руководство пользователя</a></p>
                            <p  class="info-title">Приложение распространяется, устанавливается и продается через магазин приложений ЭВОТОР.</p>
                            <p  class="info-title">Цена одной лицензии на месяц 1360 рублей.</p>
                        </div>
                    </div>
                    <div class="features text-center">
                        <div class="md-layout">
                            <div class="md-layout-item md-large-size-25 md-medium-size-33 md-small-size-100">
                                    <md-card class="md-card-custom1">
                                        <div>
                                            <img
                                                class="img kd-3"
                                                :src="image_1c_chpd"
                                            />
                                        </div>
                                        <md-card-content>
                                            <div class="md-layout">
                                                <div class="md-layout-item md-size-100">
                                                    <h6 class="card-category text-gray">
                                                        Сервис
                                                    </h6>
                                                    <h3 class="card-title">
                                                        Чек по документу 1С
                                                    </h3>

                                                </div>
                                                <div class="md-layout-item md-size-100">
                                                    <div class="kd-2">
                                                        <a href="https://market.evotor.ru/store/basket/shared/m1zLX5Pqx51lg">
                                                            <md-button class="md-simple md-round">
                                                                Установить
                                                            </md-button>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </md-card-content>
                                    </md-card>
                                </div>
                        </div>
                    </div>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100 mx-auto">
                            <h2 class="title text-center">
                                Обмен через Excel
                            </h2>
                            <p  class="info-title">
                                Приложение для ККМ ЭВОТОР.
                                Загрузка / выгрузка номенклатуры, загрузка документов в формате
                                Excel.
                                Добавление, удаление изменение товаров через веб интерфейс.
                                Ввод документов поступление, списание, инвентаризация через веб
                                интерфейс.
                            </p>
                            <p  class="info-title">Зарегистрировано в реестре российского программного обеспечения, № записи 10610, дата регистрации 27.05.2021</p>
                            <p><a href="../../docs/excel/opf.pdf">Описание функциональных характеристик программного обеспечения</a></p>
                            <p><a href="../../docs/excel/proces.pdf">Процессы жизненного цикла</a></p>
                            <p><a href="../../docs/excel/userguide.pdf">Руководство пользователя</a></p>
                            <p  class="info-title">Приложение распространяется, устанавливается и продается через магазин приложений ЭВОТОР.</p>
                            <p  class="info-title">Цена одной лицензии на 3 месяца 960 рублей.</p>
                        </div>
                    </div>
                    <div class="features text-center">
                        <div class="md-layout">
                            <div class="md-layout-item md-large-size-25 md-medium-size-33 md-small-size-100">
                                <md-card class="md-card-custom1">
                                    <div>
                                        <img
                                            class="img kd-3"
                                            :src="image_excel"

                                        />
                                    </div>
                                    <md-card-content>
                                        <div class="md-layout">
                                            <div class="md-layout-item md-size-100">
                                                <h6 class="card-category text-gray">
                                                    Редакторы товаров
                                                </h6>
                                                <h3 class="card-title">
                                                    Обмен через Excel
                                                </h3>
                                                <p class="card-description">

                                                </p>
                                            </div>
                                            <div class="md-layout-item md-size-100">
                                                <div class="kd-2">
                                                    <a href="https://market.evotor.ru/store/basket/shared/9EGNnEml45DDW">
                                                        <md-button class="md-simple md-round">
                                                            Установить
                                                        </md-button>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </md-card-content>
                                </md-card>
                            </div>
                        </div>
                    </div>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100 mx-auto text-center">
                            <h2 class="title text-center">
                                Другие наши приложения для ККМ ЭВОТОР
                            </h2>
                            <p  class="info-title">Приложения распространяется, устанавливается и продается через магазин приложений ЭВОТОР.</p>
                        </div>
                    </div>
                    <div class="features text-center">
                        <div class="md-layout">
                            <div class="md-layout-item md-large-size-25 md-medium-size-33 md-small-size-100">
                                <md-card class="md-card-custom1" style="height: 580px; min-width: 250px;">
                                    <div>
                                        <img
                                            class="img kd-3"
                                            :src="image_1c_qr"

                                        />
                                    </div>
                                    <md-card-content>
                                        <div class="md-layout">
                                            <div class="md-layout-item md-size-100">
                                                <h6 class="card-category text-gray">
                                                    Финансовые сервисы
                                                </h6>
                                                <h3 class="card-title">
                                                    Плати QR из 1С
                                                </h3>
                                                <p class="card-description">
                                                    Дополняет 1С кнопкой "Плати QR", при нажатии которой отображается QR
                                                    на ЭВОТОР POWER.
                                                    Оплата происходит после сканирования этого кода камерой телефона
                                                    через приложение Сбера. После успешной оплаты печатается чек.
                                                </p>
                                            </div>
                                            <div class="md-layout-item md-size-100">
                                                <div class="kd-2">
                                                    <a href="https://market.evotor.ru/store/basket/shared/zJabLEkMnpGDb">
                                                        <md-button class="md-simple md-round">
                                                            Установить
                                                        </md-button>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </md-card-content>
                                </md-card>
                            </div>
                            <div class="md-layout-item md-large-size-25 md-medium-size-33 md-small-size-100">
                                <md-card class="md-card-custom1" style="height: 580px; min-width: 250px;">
                                    <div>
                                        <img
                                            class="img kd-3"
                                            :src="image_qr_display"
                                        />
                                    </div>
                                    <md-card-content>
                                        <div class="md-layout">
                                            <div class="md-layout-item md-size-100">
                                                <h6 class="card-category text-gray">
                                                    Коммуникация с клиентом
                                                </h6>
                                                <h3 class="card-title">
                                                    Экран покупателя + QR
                                                </h3>
                                                <p class="card-description">
                                                    Приложение отображает набираемый чек покупателя на любом смартфоне,
                                                    планшете, устройстве с web-браузером. При совместном использовании с
                                                    "Плати QR" показывает QR-код для оплаты через Сбер. В момент показа
                                                    чека возможно отображение вашей рекламы (слайдов с картинками).
                                                </p>
                                            </div>
                                            <div class="md-layout-item md-size-100">
                                                <div class="kd-2">
                                                    <a href="https://market.evotor.ru/store/basket/shared/NbVOw8pDBddZ1">
                                                        <md-button class="md-simple md-round">
                                                            Установить
                                                        </md-button>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </md-card-content>
                                </md-card>
                            </div>
                            <div class="md-layout-item md-large-size-25 md-medium-size-33 md-small-size-100">
                                <md-card class="md-card-custom1" style="height: 580px; min-width: 250px;">
                                    <div>
                                        <img
                                            class="img kd-3"
                                            :src="image_1c_bitrix"
                                        />
                                    </div>
                                    <md-card-content>
                                        <div class="md-layout">
                                            <div class="md-layout-item md-size-100">
                                                <h6 class="card-category text-gray">
                                                    Онлайн фискализация
                                                </h6>
                                                <h3 class="card-title">
                                                    Интернет магазин чек по заказу
                                                </h3>
                                                <p class="card-description">
                                                    После получения заказа приложение на ЭВОТОР автоматически пробьет
                                                    чек и
                                                    отправит электронную версию на email или телефон (через ОФД).
                                                    Работает с 1С-Bitrix.
                                                    Так же у приложения есть API.
                                                </p>
                                            </div>
                                            <div class="md-layout-item md-size-100">
                                                <div class="kd-2">
                                                    <a href="https://market.evotor.ru/store/basket/shared/48xEO2r6qN1Z">
                                                        <md-button class="md-simple md-round">
                                                            Установить
                                                        </md-button>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </md-card-content>
                                </md-card>
                            </div>
                            <div class="md-layout-item md-large-size-25 md-medium-size-33 md-small-size-100">
                                <md-card class="md-card-custom1" style="height: 580px; min-width: 250px;">
                                    <div>
                                        <img
                                            class="img kd-3"
                                            :src="image_telebot"

                                        />
                                    </div>
                                    <md-card-content>
                                        <div class="md-layout">
                                            <div class="md-layout-item md-size-100">
                                                <h6 class="card-category text-gray">
                                                    Аналитика и отчеты
                                                </h6>
                                                <h3 class="card-title">
                                                    TelegramBot EvoRobot
                                                </h3>
                                                <p class="card-description">
                                                    Бот всегда подскажет сколько наличности в кассе, и не пора ли ее
                                                    инкассировать. Повысит дисциплину сотрудников, сообщит вам во
                                                    сколько начал и закончил работать магазин.
                                                    Вышлет отчет после закрытия смены, а если хотите может даже
                                                    оправлять хоть каждый чек, возврат, изъятие, внесение.
                                                </p>
                                            </div>
                                            <div class="md-layout-item md-size-100">
                                                <div class="kd-2">
                                                    <a href="https://market.evotor.ru/store/basket/shared/NzZ9W967J7alp">
                                                        <md-button class="md-simple md-round">
                                                            Установить
                                                        </md-button>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </md-card-content>
                                </md-card>
                            </div>
                            <div class="md-layout-item md-large-size-25 md-medium-size-33 md-small-size-100">
                                <md-card class="md-card-custom1" style="height: 350px; min-width: 250px;">
                                    <div>
                                        <img
                                            class="img kd-3"
                                            :src="image_sub"
                                        />
                                    </div>
                                    <md-card-content>
                                        <div class="md-layout">
                                            <div class="md-layout-item md-size-100">
                                                <h6 class="card-category text-gray">
                                                    Транспорт
                                                </h6>
                                                <h3 class="card-title">
                                                    Билеты междугородний транспорт
                                                </h3>
                                                <p class="card-description">
                                                    Приложение печатает билет с положенными реквизитами для
                                                    междугороднего (пригородного) и межобластного транспорта. Такими как
                                                    место и время отправления и прибытия, данные пассажира.
                                                    Маршруты, расписание, тарифная сетка настраиваются в ЛК ЭВОТОР.
                                                </p>
                                            </div>
                                            <div class="md-layout-item md-size-100">
                                                <div class="kd-2">
                                                    <a href="https://market.evotor.ru/store/basket/shared/p257rDLjddmj">
                                                        <md-button class="md-simple md-round">
                                                            Установить
                                                        </md-button>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </md-card-content>
                                </md-card>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <a name="company"></a>
            <div class="section text-center">

                <div class="container">
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100 md-small-size-100 mx-auto text-center">
                            <h2 class="title text-center">
                                О компании
                            </h2>
                            <h5  class="info-title">
                                Наша компания занимается разработкой решений для автоматизации торговли начиная с 2010 года.
                                Все права на представленные приложения принадлежат индивидуальному предпринимателю Даниловой Виде Васильевне ИНН 391000028892
                            </h5>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section text-center">
              <a name="support"></a>
                <div class="container">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100 md-small-size-100 mx-auto text-center">
                      <h2 class="title text-center">
                        Техническая поддержка пользователей
                      </h2>
                      <h5  class="info-title">
                        Всем пользователям приложений Vida-Soft техническая поддержка предоставляется бесплатно в течении всего срока использования программы.
                        Мы готовы проконсультировать вас по телефону Пн-Пт. 9:00-18:00. Срочные вопросы технической поддержки наших клиентов принимаем круглосуточно.
                      </h5>
                      <div class="md-layout-item md-layout">
                        <div class="md-layout-item md-size-50 md-small-size-100 mx-auto">
                          <info-areas
                                  info-horizontal
                                  icon-color="info"
                                  icon="fas fa-phone"
                          >
                            <h4
                                    slot="title"
                                    class="info-title"
                            >
                              Наши телефоны
                            </h4>
                            <div
                                    slot="content"
                                    class="description">
                              <p>
                                Мы готовы проконсультировать вас по телефону.
                                <br>
                                Пн-Пт. 9:00-18:00
                                <br>
                                Срочные вопросы технической поддержки принимаем круглосуточно.
                                <br>
                                <b><a href="tel:+7-800-222-02-50">8-800-222-02-50</a></b>
                                <br>
                                <b><a href="tel:+7(921)-006-68-95">+7(921)-006-68-95</a></b>
                              </p>
                            </div>
                          </info-areas>
                        </div>

                        <div class="md-layout-item md-medium-size-25 md-small-size-100 mx-auto">
                          <info-areas
                                  info-horizontal
                                  icon-color="warning"
                                  icon="fas fa-envelope"
                          >
                            <h4
                                    slot="title"
                                    class="info-title"
                            >
                              Электронная почта
                            </h4>
                            <div
                                    slot="content"
                                    class="description">
                              <p>
                                У нас регистрируется каждое письмо в системе и ему присваивается номер обращения. Поэтому ничего не потеряется. Всегда лучше нам написать.
                                <br>
                                <b>support@akitorg.ru</b>
                              </p>
                            </div>
                          </info-areas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

  import Mixins from "@/plugins/basicMixins";
  import InfoAreas from "../../components/InfoAreas.vue";


  export default {
    components: {InfoAreas},
    mixins: [Mixins.HeaderImage],
    bodyClass: "landing-page",
    data() {
      return {
        image: require("@/assets/img/bg7.jpeg"),
        image_1c_un: require("@/assets/img/1c_un.png"),
        image_1c_buh: require("@/assets/img/1c_buh.png"),
        image_1c_torg: require("@/assets/img/1c_torg.png"),
        image_1c_rozn: require("@/assets/img/1c_rozn.png"),
        image_1c_zakaz: require("@/assets/img/1c_zakaz.png"),
        image_1c_7: require("@/assets/img/1c_7.png"),
        image_1c_qr: require("@/assets/img/1c_qr.png"),
        image_qr_display: require("@/assets/img/qr_display.jpeg"),
        image_1c_chpd: require("@/assets/img/1c_chpd.png"),
        image_1c_bitrix: require("@/assets/img/bitrix.png"),
        image_telebot: require("@/assets/img/telebot.png"),
        image_excel: require("@/assets/img/excel.png"),
        image_sub: require("@/assets/img/sub.png"),
        name: null,
        email: null,
        message: null,
        cardProfile3: {
          cardProfile1: require("@/assets/img/faces/card-profile1-square.jpg"),
          cardProfile2: require("@/assets/img/faces/card-profile6-square.jpg"),
          cardProfile3: require("@/assets/img/faces/card-profile4-square.jpg"),
          cardProfile4: require("@/assets/img/faces/card-profile2-square.jpg")
        }
      };
    }
  };
</script>

<style lang="scss" scoped>
  @media screen and (min-width: 1200px) {
    .md-card-custom1 {
      height: 300px;
    }
  }
  @media screen and (max-width: 1199px) {
    .md-card-custom1 {
      height: 550px;
    }
  }
  @media screen and (max-width: 991px) {
    .md-card-custom1 {
      height: 710px;
      min-width: 190px;
    }
  }

  @media screen and (max-width: 960px) {
    .md-card-custom1 {
      height: 400px;
      min-width: 190px;
    }
  }



  .md-card-actions.text-center {
        display: flex;
        justify-content: center !important;
    }

    .contact-form {
        margin-top: 30px;
    }

    .md-has-textarea + .md-layout {
        margin-top: 15px;
    }

    .kd-2 {
        height: 30px;
        width: 100%;
        position: absolute;
        bottom: 25px;
        left: 0px;
    }
  .kd-3 {
    width: 100px;height: 100px; margin: 15px;  border-radius: 10px;
  }
</style>
